export enum ChartColors {
  Primary100 = '#20408A',
  Primary200 = '#2953B2',
  Primary300 = '#9CB3E8',
  Success100 = '#00875A',
  Success200 = '#00875A',
  Success300 = '#80C3AD',
  MdAccent100 = '#DD3A2A',
  MdAccent200 = '#DD3A2A',
  MdAccent300 = '#EE9C94'
}
